<template>
    <div class="user-page">
        <h2>用户注册和服务协议</h2>
        <br>
        <P>　　用户注册和服务协议</P>
        <P>　　欢迎您参加由ALIENWARE品牌发起的向全网征集符合“挑战边界”主题的游戏内容的活动。</P>
        <P>　　本协议系由您(或称“用户”)与ALIENWARE品牌(或称“我们”)之间就 挑战边界·72Hours行动 活动(以下或简称“活动”)而签订。</P>
        <P>　　在参加本活动之前，请您务必审慎阅读、充分理解本协议(如果您未满16周岁，或已满16周岁未满18周岁且不能以自己的劳动收入作为主要收入来源的，请在法定监护人的陪同下阅读本协议)各项条款，特别是限制或免除责任条款、隐私保护政策、法律适用和争议解决条款(包括管辖条款)，以及其它以<strong>加粗加黑</strong>和/或加下划线等显示形式提示您注意的重要条款，请务必重点查阅。
        </P>
        <P>　　若您不同意本协议，则您有充分且完全的权利退出活动，您通过网络页面点击注册和/或实际参加活动的行为即视为您已阅读、理解并同意接受本协议。</P>
        <P>　　<strong>1. 基础约定</strong></P>
        <P>　　1.1. 协议范围：为了更全面的界定您与ALIENWARE品牌之间的权利义务，本协议</P>
        <P>　　包括我们根据法律法规规定以及根据本协议制定的其他政策、规则、公告声明等(除非特有所指，合称为“本协议”)，您也应当加以遵守。</P>
        <P>　　1.2. 修改与更新：我们有权遵照法律法规规定，在必要时修改本协议(包括适时</P>
        <P>　　制定并发布其他政策、规则、公告声明)，更新后的协议条款将代替原来的协议并在法律规定的期限届满后正式生效，您可以在相关服务页面查阅最新版本的协议条款。本协议修改后，如果您继续参加活动的，即视为您已接受修改后的协议。如果您不接受修改后的协议，则您有权利拒绝参加活动。
        </P>
        <P>　　1.3. 除非ALIENWARE品牌另行声明，我们在本活动中所生成、制作、推出的所</P>
        <P>　　有产品、技术、软件、程序、数据及相关内容信息(包括文字、图片、音视频、网页版面、图表、数据等权利和权益内容)的所有权利(包括知识产权、商业秘密及其他相关权利)均归ALIENWARE品牌及/或其关联公司所有。未经ALIENWARE品牌及/或其关联公司许可，任何人擅自使用上述内容，均可能会侵犯ALIENWARE品牌及/或其关联公司的权利，我们将会追究侵权者的法律责任。
        </P>
        <P>　　1.4. 本活动中的商标性文字及/或图形标识，服务运营商字号名称等均为Aline</P>
        <P>　　ware品牌及/或其关联公司在中国和其他国家所拥有的商标等权利，如有宣传、展示等任何使用需要，您必须取得ALIENWARE品牌及/或其关联公司事先书面授权。</P>
        <P>　　<strong>2. 平台服务内容</strong></P>
        <P>　　2.1. 本次活动为ALIENWARE品牌发起的向全网征集符合“挑战边界”主题的游</P>
        <P>　　戏内容的活动。征集物料分为2个赛道：游戏DEMO(游戏程序)和游戏创意(关于游戏的图片文字说明)。</P>
        <P>　　2.2. 请您理解并知悉，您在分享内容至您的社交软件时，应当保护好您的个人</P>
        <P>　　信息，若因此发生相关法律问题与风险，与我们无关。</P>
        <P>　　2.3. 本次活动需要您进行实名注册，为判断或核实您提供的相关实名注册信息</P>
        <P>　　是否真实或有效，我们有权将您提供的实名注册信息提供给第三方进行整理、保存及比对等处理。</P>
        <P>　　2.4. 为达成活动目的以及提升用户体验，我们有权根据活动实际情况在您同意/选择后优化和引入第三方服务。由此发生的法律关系是由您和该等第三方服务商之间形成，和ALIENWARE品牌无关。</P>
        <P>　　2.5.
            您同意并知悉，活动中的具体内容、功能和形式由ALIENWARE品牌根据实际情况按实际可见的状态提供，我们有权自行确定活动的具体内容和形式(例如，我们可能仅在特定的国家或地区以特定的语言提供)，有权自行决定增加、变更、中断和停止活动的内容和形式。
        </P>
        <P>　　<strong>3. 用户行为规范</strong></P>
        <P>　　3.1. 您保证合理地参加活动，并接受本协议和我们适时制定并发布的其他政策、</P>
        <P>　　规则、公告声明。您保证您在参加活动过程中不会以未经我们许可的任何方式录制、直播或向他人传播其他用户上传的游戏内容，包括但不限于不得利用任何第三方软件进行网络直播、传播等。</P>
        <P>　　3.2. 行为禁止：您不得利用活动从事以下行为：</P>
        <P>　　3.2.1. 超出授权或恶意使用活动信息;</P>
        <P>　　3.2.2.
            上传游戏内容包含危害国家安全、国家统一、社会稳定的内容，或侮辱诽谤、色情、暴力、引起他人不安及任何违反国家法律法规政策的内容，或者设置含有上述内容的网名、角色名，发布、传送、传播违法广告信息、营销信息及垃圾信息等;
        </P>
        <P>　　3.2.3. 上传游戏内容及创意侵害他人知识产权、肖像权、隐私权、名誉权、个人信息等合法权利或权益;</P>
        <P>　　3.2.4. 恶意虚构或协助虚构事实、评价等信息或数据;</P>
        <P>　　3.2.5.
            进行任何危害计算机网络安全的行为，包括但不限于：使用未经许可的数据或进入未经许可的服务器/账户;未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息;未经许可，企图探查、扫描、测试系统或网络的弱点或其它实施破坏网络安全的行为;企图干涉、破坏本活动系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为;伪造TCP/IP数据包名称或部分名称;利用平台及服务上传任何病毒、木马，或者蠕虫等危害网络健康的内容;
        </P>
        <P>　　3.2.6.
            通过反向工程、反向编译或反向汇编或以其它方式企图发现活动/游戏的源代码和算法，未经许可修改、禁用游戏的任何功能或创建基于游戏的衍生作品。去除本活动中的任何所有权声明或标签，或将其他活动与本次活动的平台合并;</P>
        <P>　　3.2.7.
            进行任何破坏我们提供服务公平性或者其他影响应用正常秩序的行为，如主动或被动刷分、合伙作弊、使用外挂或者其他的作弊软件、利用BUG(又叫“漏洞”或者“缺陷”)来获得不正当的非法利益，或者利用互联网或其他方式将外挂、作弊软件、BUG公之于众;
        </P>
        <P>　　3.2.8. 从事其他法律法规、政策及公序良俗、社会公德禁止的行为以及侵犯其他个人、公司、社会团体、组织的合法权益的行为。</P>
        <P>　　<strong>3.3.
            信息内容规范：为了营造良好网络生态，保障公民、法人和其他组织的合法权益，维护国家安全和公共利益，我们将根据《中华人民共和国国家安全法》《中华人民共和国网络安全法》《互联网信息服务管理办法》等法律、行政法规，自觉践行社会主义核心价值观，营造清朗的网络空间，并开展的弘扬正能量、处置违法和不良信息等相关活动。用户亦承诺遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等“七条底线”。</strong>
        </P>
        <P>　　<strong>3.3.1. 我们鼓励您制作、复制、发布含有下列内容的信息：</strong></P>
        <P>　　3.3.1.1.宣传习近平新时代中国特色社会主义思想，全面准确生动解读中国特色社会主义道路、理论、制度、文化的;</P>
        <P>　　3.3.1.2.宣传党的理论路线方针政策和中央重大决策部署的;</P>
        <P>　　3.3.1.3.展示经济社会发展亮点，反映人民群众伟大奋斗和火热生活的;</P>
        <P>　　3.3.1.4.弘扬社会主义核心价值观，宣传优秀道德文化和时代精神，充分展现中华民族昂扬向上精神风貌的;</P>
        <P>　　3.3.1.5.有效回应社会关切，解疑释惑，析事明理，有助于引导群众形成共识的;</P>
        <P>　　3.3.1.6.有助于提高中华文化国际影响力，向世界展现真实立体全面的中国的;</P>
        <P>　　3.3.1.7.其他讲品味讲格调讲责任、讴歌真善美、促进团结稳定等的内容。</P>
        <P>　　<strong>3.3.2. 您不得制作、复制、发布含有下列内容的违法信息：</strong></P>
        <P>　　3.3.2.1.反对宪法所确定的基本原则的;</P>
        <P>　　3.3.2.2.危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的;</P>
        <P>　　3.3.2.3.损害国家荣誉和利益的;</P>
        <P>　　3.3.2.4.歪曲、丑化、亵渎、否定英雄烈士事迹和精神，以侮辱、诽谤或者其他方式侵害英雄烈士的姓名、肖像、名誉、荣誉的;</P>
        <P>　　3.3.2.5.宣扬恐怖主义、极端主义或者煽动实施恐怖活动、极端主义活动的;</P>
        <P>　　3.3.2.6.煽动民族仇恨、民族歧视，破坏民族团结的;</P>
        <P>　　3.3.2.7.破坏国家宗教政策，宣扬邪教和封建迷信的;</P>
        <P>　　3.3.2.8.散布谣言，扰乱经济秩序和社会秩序的;</P>
        <P>　　3.3.2.9.散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的;</P>
        <P>　　3.3.2.10.侮辱或者诽谤他人，侵害他人名誉、隐私和其他合法权益的;</P>
        <P>　　3.3.2.11.法律、行政法规禁止的其他内容。</P>
        <P>　　3.3.3. 我们也将依法采取措施，防范和抵制制作、复制、发布含有下列内容的不良信息：</P>
        <P>　　3.3.3.1.使用夸张标题，内容与标题严重不符的;</P>
        <P>　　3.3.3.2.炒作绯闻、丑闻、劣迹等的;</P>
        <P>　　3.3.3.3.不当评述自然灾害、重大事故等灾难的;</P>
        <P>　　3.3.3.4.带有性暗示、性挑逗等易使人产生性联想的;</P>
        <P>　　3.3.3.5.展现血腥、惊悚、残忍等致人身心不适的;</P>
        <P>　　3.3.3.6.煽动人群歧视、地域歧视等的;</P>
        <P>　　3.3.3.7.宣扬低俗、庸俗、媚俗内容的;</P>
        <P>　　3.3.3.8.可能引发未成年人模仿不安全行为和违反社会公德行为、诱导未成年人不良嗜好等的;</P>
        <P>　　3.3.3.9.其他对网络生态造成不良影响的内容。</P>
        <P>　　<strong>3.4. 信息内容的使用规范</strong></P>
        <P>　　3.4.1. 未经我们书面许可，您不得自行或授权、允许、协助任何第三人对活动中信息内容进行如下行为：</P>
        <P>　　3.4.1.1.复制、读取、采用活动的信息内容，用于任何形式的商业用途;</P>
        <P>　　3.4.1.2.擅自编辑、整理、编排活动相关的信息内容后在活动平台及相关服务的源页面以外的渠道进行展示;</P>
        <P>　　3.4.1.3.采用不正当方式，自行或协助第三人对本活动及相关服务的信息内容产生流量、阅读量或交易引导、转移、劫持等不利影响。</P>
        <P>　　<strong>4. 个人信息保护与隐私政策</strong></P>
        <P>　　4.1.
            尊重用户隐私并保护您的个人信息安全是我们的一贯态度，我们将会采取合理的措施保护您的个人信息与隐私。我们承诺，除非获得您同意，我们不会收集、使用其提供服务所必需以外的用户个人信息或者将信息用于活动之外的目的。</P>
        <P>　　4.2. 用户信息包括：</P>
        <P>　　4.2.1. 个人信息，指用户在参加本活动时，我们获取得到的用户性别信息、微信ID、手机等参加本活动必要的个人信息。如您拒绝提供上述信息，将可能导致您无法继续参加本次活动。</P>
        <P>　　4.2.2.
            录音信息，指用户通过软件或硬件设备录取的个人声音信息。受技术条件影响，音频起始时间、音频长短及效果，以最终应用生成的结果为准。录音信息仅用于本活动使用，如果您拒绝提供个人音频信息，将可能导致您无法使用活动平台的录音及合成功能。
        </P>
        <P>　　4.2.3. 日志信息，指用户参与本活动时，系统可能会通过
            cookies或其他方式自动采集的技术信息，包括：设备或软件信息，例如您的移动设备、网页浏览器或您用于参加本活动的其他程序所提供的配置信息、您的IP地址和您的移动设备所用的版本和设备识别码;您通过本次活动分享的内容所包含的信息(元数据)，例如上传的游戏Demo的日期、时间或地点等。
        </P>
        <P>　　4.2.4. 位置信息，指您开启设备定位功能，本活动收集的有关您的位置信息，包括：您通过具有定位功能的移动设备参加活动时，我们通过 GPS 或 WiFi
            等方式收集的您的地理位置信息;您或其他用户提供的包含您本人所处地理位置的实时信息。用户可以通过关闭定位功能随时停止本活动对用户的地理位置信息的收集。</P>
        <P>　　4.2.5. 用户在参加本活动过程中所提供的或者本活动合法收集的其他必要信息。</P>
        <P>　　4.3.
            安全保护：我们将运用各种安全技术和程序建立完善的管理制度来保护您的个人信息及隐私安全，以免遭受未经授权的访问、使用或披露。本活动仅在本协议所述目的所必需期间和法律法规要求的时限内保留用户的信息。我们会根据合法、正当、必要的原则，仅收集实现产品功能所必要的信息
        </P>
        <P>　　4.4.
            保护用户个人信息是本活动的一项基本原则，本活动将会采取合理的措施保护用户的个人信息。除法律法规规定及本协议约定的情形外，未经用户许可本活动主办方不会向第三方公开、透露用户个人信息。本活动主办方使用各种安全技术和程序，以防用户信息的丢失、不当使用、未经授权阅览或披露，但由于不可抗力、现有技术限制等非本公司原因导致的用户信息丢失，本活动主办方不承担责任。
        </P>
        <P>　　4.5.
            我们有权在遵守法律法规的前提下，以明示的方式获取、使用、储存和分享您的个人信息。我们不会在未经您授权时，公开、编辑或透露您的个人信息及您保存在我们的非公开内容。您同意并保证：我们有权根据我们制定的个人信息保护规则收集使用您的相关信息。
        </P>
        <P>　　4.6. 本活动可能包括或链接至第三方提供的社交媒体或其他服务。您使用该等第三方的社交媒体服务或其他服务，须遵守该第三方的有关用户信息的条款约束，由于该第三方原因导致的用户信息泄露、丢失，本活动主办方不承担责任。
        </P>
        <P>　　4.7. 未成年人应在父母或监护人指导下，认真阅读并同意本协议后，方可参加本次活动。</P>
        <P>　　4.8. 对外提供</P>
        <P>　　4.8.1. 本活动不会对外公开披露所收集的个人信息，如必须公开披露时，我们会向您告知此次公开披露的目的、披露信息的类型及可能涉及的敏感信息，并征得您的明示同意。</P>
        <P>　　4.8.2. 另外，根据相关法律法规及国家标准，以下情形中，本活动可能会共享、转让、公开披露个人信息无需事先征得您的授权同意：</P>
        <P>　　4.8.2.1.与国家安全、国防安全直接相关的;</P>
        <P>　　4.8.2.2.与公共安全、公共卫生、重大公共利益直接相关的;</P>
        <P>　　4.8.2.3.与犯罪侦查、起诉、审判和判决执行等直接相关的;</P>
        <P>　　4.8.2.4.出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的;</P>
        <P>　　4.8.2.5.个人信息主体自行向社会公众公开个人信息的;</P>
        <P>　　4.8.2.6.从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</P>
        <P>　　4.9. 在遵守本协议项下特别约定的个人信息保护与隐私政策外，我们希望您</P>
        <P>　　认真并完整阅读我们特别针对平台而制定并适时发布的《隐私权政策》，这将更有助于保障您的个人信息。</P>
        <P>　　<strong>5. 信息或广告推送</strong></P>
        <P>　　5.1. 您同意在参加活动的同时，允许我们在遵守法律法规的前提下自行或由第三方广告商向您发送、展示广告、推广或宣传信息(包括商业与非商业信息)。</P>
        <P>　　<strong>6. 知识产权等权益</strong></P>
        <P>　　6.1. 我们对活动中所包含的受知识产权或其他法律保护的资料享有相应的权利;除依法由您享有著作权的内容之外，活动的整体内容的知识产权归我们或关联公司所有。</P>
        <P>　　6.2.
            您在参加活动时所上传的文字、图片、视频、软件、小程序以及表演等原创信息的知识产权归您所有(或由第三方内容提供方和您另行约定)，但是基于ALIENWARE品牌运营的需求，您确认您对该等信息的发表、上传行为视同为对我们非独占地、永久地、不可撤销地授予该等信息相关全部知识产权的使用、复制等权利，并且您同意我们可转授权上述权利。
        </P>
        <P>　　6.3. 您在上传相关作品时应保证，对为本活动所提供的内容有权转让作品的著作权，即您为该作品的原作者，对该作品拥有合法的完整的著作权。</P>
        <P>　　6.4.
            您在上传相关作品时应保证，为本活动所提供的内容，不侵犯他人的著作权、商标、专利权和商业秘密等知识产权。如因您提供的内容导致侵犯第三人合法权益的，由此而产生的任何纠纷均由您负责解释、处理并承担一切相应责任，ALIENWARE品牌方将不承担任何责任。如因您侵权行为给ALIENWARE品牌方造成损失的(包括但不限于律师费、误工费)，由您承担全部赔偿责任。
        </P>
        <P>　　6.5. 您同意将上传至平台的作品，授权给ALIENWARE品牌进行展示和传播使用。</P>
        <P>　　6.6. 你同意将自己上传的作品/创意/demo由ALIENWARE品牌开放给全网用户进行试玩。</P>
        <P>　　6.7. 基于对数据的合法加工而获得的具有竞争性的数据权益，除法律法规另有规定外，我们享有独立的使用权益而无须获得您的同意。</P>
        <P>　　6.8. 关于信息内容的投诉或举报。若您在参与活动过程中，合法权益受到侵犯，您有权通知我们采取必要措施进行处置。</P>
        <P>　　6.9. 内容维权授权。在法律法规允许的范围内，您同意并授权我们就侵犯您合法权益的行为(包括但不限于私自复制、使用、编辑、抄袭等行为)采取任何形式的法律行动，包括但不限于投诉、诉讼等必要的维权措施。</P>
        <P>　　<strong>7. 免责声明</strong></P>
        <P>　　7.1.
            我们对于您自平台而获得的所有他人、第三方的信息、内容或者广告宣传等任何资讯(以下统称“信息”)，除法律明确规定外，不保证真实、准确和完整性。如果任何单位或者个人通过上述“信息”而进行任何行为，您须自行甄别真伪和谨慎预防风险。您在参加活动时，有可能会接触到令人不快、不适当或令人厌恶的内容，在任何情况下，我们均不对任何此等内容承担任何责任。无论何种原因，我们不对任何非与我们直接发生的交易或行为承担任何直接、间接、附带或衍生的损失和责任。
        </P>
        <P>　　7.2. 鉴于互联网服务的特殊性，您理解并同意我们在以下情况下无需对您所遭受的损失(包括但不限于财产、收益、数据资料等方面的损失或其它无形损失)承担责任：</P>
        <P>　　7.2.1. 因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力之因素导致平台及服务障碍不能正常运作;</P>
        <P>　　7.2.2. 由于计算机病毒、木马、其他恶意程序、黑客攻击、电信部门及网络运营公司技术调整或故障、系统维护等意外原因而造成平台及服务中断或延迟。</P>
        <P>　　<strong>8. 违约责任</strong></P>
        <P>　　8.1. 如果我们发现、收到他人举报或投诉您违反本协议约定或违反法律法规和国家有关规定的，我们有权采取警示、终止/中止/限制您参加本次活动，解除或终止本协议，或提出损害赔偿等措施。</P>
        <P>　　8.2. 若您的行为给我们造成损失的(包括但不限于直接损失、名誉损失、第三方的罚款、索赔等)，我们有权全额向您追偿。</P>
        <P>　　8.3.
            本协议终止后，除法律有明确规定外，我们无义务向您或您指定的第三方披露您的任何信息。本协议终止后，我们仍享有下列权利：根据法律规定，继续保存您留存于平台的的各类信息;对于您过往的违约行为，我们仍可依据本协议向您追究违约责任。
        </P>
        <P>　　<strong>9. 法律适用与管辖</strong></P>
        <P>　　9.1. 本协议的订立、执行、解释及争议的解决均适用中华人民共和国法律。</P>
        <P>　　9.2. 如双方就服务协议内容或其履行发生任何争议，双方应尽力友好协商解决;协商不成时，任何一方均可向北京市海淀区人民法院提起诉讼。</P>
        <P>　　<strong>10. 如何联系我们</strong></P>
        <P>　　10.1. 如果您有任何的疑问、投诉、意见和建议，欢迎您与我们沟通反馈。我们的联系方式见下：</P>
        <P>　　客服邮箱：<a href="mailto:jianxun.wang@99ntc.com">jianxun.wang@99ntc.com</a></P>
        <P>　　本版本发布/更新日期：2022年4月29日</P>
    </div>
</template>

<script>
export default {
    name: "UserAgreement",
};
</script>

<style lang="scss" scoped>
.user-page {
    width: 100%;
    background: #00036b url('https://oss.eventnet.cn/H5/72Hours/pc/bg.jpg') top no-repeat;
    background-size: contain;
    padding: 80px 40px;

    h2 {
        color: #2afcf5;
        text-align: center;
    }

    p {
        font-weight: 100;
        line-height: 1.5;
        color: #2afcf5;

        strong {
            font-weight: 400;
        }

        a {
            color: #2afcf5;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/UserAgreement.vue